import React from 'react';
import './Video.css';

function Video() {
  return (
    <div className="app-video w-full grid justify-items-center">
      <div className="section">
        <div className="sm:p-20 sm:grid-cols-2 grid xs:grid-rows-2 place-content-evenly gap-2 p-4">
          <div className="sm:pr-20 md:content-center">
            <div className="text-xl sm:text-3xl font-semibold">
                Domine as técnicas dos poliglotas respeitando o seu jeito de ser
            </div>
            <div className="pt-4 pb-4 text-base sm:text-2xl">
                Promovemos educação por meio de nossa mentoria para quem sonha em ser fluente em idiomas
            </div>
          </div>

          <div className="col-span-1 p-1 app-video">
              <iframe width="100%" height="360" src="https://www.youtube.com/embed/mUiOPhPUMRo" title="Apresentação programa Destino Poliglota" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Video;
